import { Box, Typography, Container, Grid, Paper, Avatar, CssBaseline } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import LockIcon from "@mui/icons-material/Lock";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import Navbar from "../../layout/Navbar";
import DrawerHeader from "../../layout/DrawerHeader";

const Home = ({ isForecastAccessible }: { isForecastAccessible: boolean }) => {
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user);

  const menu = [
    {
      icon: <PriceChangeIcon sx={{ fontSize: 45 }} />,
      title: "Chiffrage Projets",
      subtitle: "Estimez vos charges de développement (CDC)",
      link: "/chiffrageCDC",
      disabled: false,
      color: "#3b82f6"
    },
    {
      icon: <CalendarMonthIcon sx={{ fontSize: 45 }} />,
      title: "Chiffrage Prévisionnel",
      subtitle: "Gérez votre rentabilité annuelle et versions",
      link: "/prévisionnel",
      disabled: !isForecastAccessible,
      color: "#f59e0b"
    },
    {
      icon: <ReceiptLongIcon sx={{ fontSize: 45 }} />,
      title: "Navette de paie",
      subtitle: "Préparez les données mensuelles pour la paie",
      link: "/navette-paie",
      disabled: false,
      color: "#10b981"
    },
    {
      icon: <RequestQuoteIcon sx={{ fontSize: 45 }} />,
      title: "Matrice Régie",
      subtitle: "Simulez un TJM proposé en régie",
      link: "/regie/simulation",
      disabled: false,
      color: "#8b5cf6"
    }
  ];

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f8fafc" }}>
      <CssBaseline />
      
      {/* HEADER UNIQUE SANS BOUTON MENU */}
      <Navbar showMenuButton={false} />

      <Container maxWidth="lg" sx={{ pt: 12 }}>
        <DrawerHeader />
        
        <Box sx={{ mb: 8, textAlign: "center" }}>
          <Typography variant="h3" sx={{ fontWeight: 900, color: "#1e293b", mb: 1, letterSpacing: "-1.5px" }}>
            Bienvenue sur Kairos
          </Typography>
          <Typography variant="h6" sx={{ color: "#64748b", fontWeight: 400 }}>
            Bonjour {user?.username || "Gérant"}, quel module souhaitez-vous utiliser ?
          </Typography>
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {menu.map((item, index) => (
            <Grid item xs={12} sm={6} md={5} key={index}>
              <Paper
                elevation={0}
                onClick={() => !item.disabled && navigate(item.link)}
                sx={{
                  p: 5,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "24px",
                  border: "1px solid #e2e8f0",
                  transition: "all 0.3s ease",
                  cursor: item.disabled ? "not-allowed" : "pointer",
                  position: "relative",
                  "&:hover": {
                    transform: item.disabled ? "none" : "translateY(-10px)",
                    boxShadow: item.disabled ? "none" : "0 25px 50px -12px rgba(0, 0, 0, 0.08)",
                    borderColor: item.disabled ? "#e2e8f0" : item.color,
                  }
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
                  <Avatar sx={{ bgcolor: `${item.color}15`, color: item.color, width: 80, height: 80, borderRadius: "20px" }}>
                    {item.icon}
                  </Avatar>
                  {item.disabled && (
                    <Box sx={{ color: "#94a3b8", display: "flex", alignItems: "center", gap: 0.5 }}>
                       <LockIcon fontSize="small" />
                       <Typography variant="caption" sx={{ fontWeight: 800 }}>RESTREINT</Typography>
                    </Box>
                  )}
                </Box>

                <Typography variant="h5" sx={{ fontWeight: 800, color: "#1e293b", mb: 1.5 }}>
                  {item.title}
                </Typography>
                <Typography variant="body1" sx={{ color: "#64748b", mb: 4, lineHeight: 1.6 }}>
                  {item.subtitle}
                </Typography>

                <Box sx={{ mt: "auto", display: "flex", alignItems: "center", gap: 1, color: item.disabled ? "#94a3b8" : item.color }}>
                  <Typography variant="button" sx={{ fontWeight: 700 }}>
                    {item.disabled ? "Indisponible" : "Lancer le module"}
                  </Typography>
                  {!item.disabled && <ArrowForwardIcon sx={{ fontSize: 18 }} />}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Home;